import { motion } from "framer-motion";
import { fadeUp, fadeUpSlow, stagger, viewportOnce } from "../lib/motion";

const Chip = ({ children, accent = false, testid }) => (
    <span
        data-testid={testid}
        className={`inline-flex items-center gap-2.5 border px-5 py-3 font-mono text-[13px] tracking-[0.22em] ${
            accent
                ? "border-accent/70 text-accent"
                : "border-white/25 text-white/90"
        }`}
    >
        <span
            className={`h-1.5 w-1.5 ${accent ? "bg-accent" : "bg-white/40"}`}
        />
        {children}
    </span>
);

const Connector = () => (
    <svg
        width="48"
        height="12"
        viewBox="0 0 48 12"
        fill="none"
        aria-hidden="true"
        className="shrink-0"
    >
        <path d="M0 6h40" stroke="#FF5B00" strokeWidth="1" />
        <path d="M37 2l6 4-6 4" stroke="#FF5B00" strokeWidth="1" fill="none" />
    </svg>
);

const QuoteAnalyzer = () => (
    <section
        data-testid="quote-analyzer"
        className="relative overflow-hidden border-y border-white/10 bg-surface/40 py-24 lg:py-36"
    >
        <div className="blueprint-bg blueprint-fade pointer-events-none absolute inset-0 opacity-60" />
        <div className="relative mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <motion.div
                variants={stagger}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
            >
                <motion.p
                    variants={fadeUp}
                    className="flex items-center gap-3 font-mono text-[13px] tracking-[0.3em] text-mist"
                >
                    <span className="h-1.5 w-1.5 bg-accent" />
                    QUOTE ANALYZER
                </motion.p>

                <motion.h2
                    variants={fadeUpSlow}
                    data-testid="quote-analyzer-headline"
                    className="mt-10 max-w-4xl text-4xl font-light leading-[1.1] text-white md:text-6xl"
                >
                    Your contractor's price.
                    <span className="block text-mist">
                        The market context.
                    </span>
                    <span className="block">
                        One clearer picture
                        <span className="text-accent">.</span>
                    </span>
                </motion.h2>

                <motion.p
                    variants={fadeUp}
                    className="mt-8 max-w-xl text-[16px] leading-relaxed text-mist"
                >
                    BuildEase can help homeowners compare quotation
                    information against relevant verified market data — bringing
                    both into one view, so you can ask better questions and
                    make decisions with greater clarity.
                </motion.p>

                <motion.div
                    variants={fadeUp}
                    className="mt-12 flex flex-wrap items-center gap-5"
                >
                    <Chip testid="quote-chip-quotation">QUOTATION</Chip>
                    <Connector />
                    <Chip testid="quote-chip-market-data">
                        VERIFIED MARKET DATA
                    </Chip>
                    <Connector />
                    <Chip accent testid="quote-chip-clearer-picture">
                        CLEARER PICTURE
                    </Chip>
                </motion.div>
            </motion.div>
        </div>
    </section>
);

export default QuoteAnalyzer;
